module.exports = __webpack_public_path__ + "static/MAZIUSREVIEW20.09-Extraitalic-89a6976e5d8dee12d7941c7a0a823642.woff2";